export default __webpack_public_path__ + "static/mug-20f5c6f6e519e1bf21142d2fd47a3f75.png";